export interface Config {
  token: string
  projectSlug: string
}

export interface Env {
  name: string
  value: string
}
